import React, { Component } from "react";
import { Link } from "react-router-dom";

import ImgLogo from "../../images/logohw.png";

export class Footer extends Component {
  render = () => {
    const currentYear = new Date().getFullYear();

    const services = [
      { name: "Asesorías Contables", link: "/servicios/asesorias-contables" },
      { name: "Creación de Empresa", link: "/servicios/creacion-empresa" },
      {
        name: "Auditoría de Comunidades",
        link: "/servicios/auditoria-comunidades",
      },
      {
        name: "Diagnóstico Tributario",
        link: "/servicios/diagnostico-tributario",
      },
      {
        name: "Planificación de Renta 2027",
        link: "/servicios/planificacion-renta-2027",
      },
    ];

    return (
      <footer className="modern-footer">
        <div className="footer-main">
          <div className="auto-container">
            <div className="footer-content-wrapper">
              {/* Company Info Section */}
              <div className="footer-column footer-company">
                <div className="footer-logo">
                  <Link to="/">
                    <img src={ImgLogo} alt="Contasi Logo" />
                  </Link>
                </div>
                <p className="footer-description">
                  Más de 20 años de experiencia brindando soluciones contables,
                  tributarias y de auditoría para pequeñas y medianas empresas
                  en Chile.
                </p>
                <div className="footer-social">
                  <a
                    href="https://wa.me/56961922323"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-link whatsapp"
                  >
                    <i className="fab fa-whatsapp"></i>
                  </a>
                  <a
                    href="mailto:contacto@contasi.cl"
                    className="social-link email"
                  >
                    <i className="fas fa-envelope"></i>
                  </a>
                  <a href="tel:+56961922323" className="social-link phone">
                    <i className="fas fa-phone"></i>
                  </a>
                </div>
              </div>

              {/* Services Section */}
              <div className="footer-column footer-services">
                <h3 className="footer-title">Nuestros Servicios</h3>
                <ul className="footer-links">
                  {services.map((service, index) => (
                    <li key={index}>
                      <Link to={service.link}>
                        <i className="fas fa-chevron-right"></i>
                        {service.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Contact Info Section */}
              <div className="footer-column footer-contact">
                <h3 className="footer-title">Información de Contacto</h3>
                <div className="contact-info-list">
                  <div className="contact-item">
                    <div className="contact-icon">
                      <i className="fas fa-map-marker-alt"></i>
                    </div>
                    <div className="contact-details">
                      <span className="contact-label">OFICINA</span>
                      <span className="contact-value">
                        12 Norte 785, Of. 406. Viña del Mar
                      </span>
                    </div>
                  </div>

                  <div className="contact-item">
                    <div className="contact-icon">
                      <i className="fas fa-envelope"></i>
                    </div>
                    <div className="contact-details">
                      <span className="contact-label">EMAIL</span>
                      <a
                        href="mailto:contacto@contasi.cl"
                        className="contact-value"
                      >
                        contacto@contasi.cl
                      </a>
                    </div>
                  </div>

                  <div className="contact-item">
                    <div className="contact-icon">
                      <i className="fas fa-phone"></i>
                    </div>
                    <div className="contact-details">
                      <span className="contact-label">TELÉFONOS</span>
                      <div className="phone-numbers">
                        <a href="tel:+56961922323" className="contact-value">
                          +56 9 6192 2323
                        </a>
                      </div>
                    </div>
                  </div>

                  <div className="contact-item">
                    <div className="contact-icon">
                      <i className="fas fa-clock"></i>
                    </div>
                    <div className="contact-details">
                      <span className="contact-label">HORARIOS</span>
                      <span className="contact-value">
                        Lun - Vie: 9:00 - 19:00
                        <br />
                        <small>Sáb, Dom y Festivos: Cerrado</small>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="auto-container">
            <div className="footer-bottom-content">
              <div className="copyright">
                <p>
                  © {currentYear} <strong>Contasi</strong>. Todos los derechos
                  reservados.
                </p>
                <p className="legal-text">
                  Servicios profesionales de contabilidad y tributación en Chile
                </p>
              </div>
              <div className="footer-bottom-links">
                <Link to="/empresa">Sobre Nosotros</Link>
                <Link to="/contacto">Contacto</Link>
                <a href="tel:+56961922323">Llamar Ahora</a>
              </div>
            </div>
          </div>
        </div>
      </footer>
    );
  };
}

export default Footer;
